module.exports = __webpack_public_path__ + "static/media/image.0446e730.svg";